<template>
  <div>
    <div class="story">
      <div class="block">
        <div>Darlin Ness,</div>
        <br />
        <div>HAPPY FIRST MONTHIVERSARY! ❤️</div>
        <br />
        <div @click="play" class="play">play</div>
      </div>
      <!-- <div class="block" style="font-size: 85px">🦩🍓🍨</div> -->
      <!-- <div class="block">
        We've done {{ sessions.length }} sessions together.
      </div> -->
      <!-- <div class="block">
        <div class="datetime">May 3</div>
        <br />
        <div>... Robert messages Nessrine on Mooclab.</div>
      </div> -->
      <div class="images">
        <img
          class="image"
          src="https://ik.imagekit.io/elysiumone/image_yD8jfwLIk3.png"
        />
        <!-- <img
          class="image"
          src="https://ik.imagekit.io/elysiumone/Screen_Shot_2021-08-02_at_11.24.32_O7UpPGjnR1N.png"
        /> -->
      </div>
      <!-- Outro song -->
      <!-- That Girl song -->
      <!-- Make You Happy -->
      <!-- You and me, always forever. -->

      <!-- Make my narration of this. -->
    </div>
  </div>
</template>

<script>
// import { getSessionsForIDs } from "./InternalRequests";
export default {
  name: "Us",
  mounted() {
    // let audio = new Audio(require("./Ness/us.mp3"));
    //   audio.file.currentTime = 0;
    //   audio.file.isPlaying = true;
    //   audio.file.volume = 0.5;
    // audio.play();
  },
  methods: {
    play() {
      let audio = new Audio(require("./Ness/two.mp3"));
      audio.currentTime = 0;
      audio.isPlaying = true;
      audio.volume = 0.5;
      audio.play();
    },
  },
  //   async created() {
  //     await this.getSessionsForIDs();
  //   },
  //   data() {
  //     return {
  //       UID_1: "5ffa95888d24191c09f7f0bb",
  //       UID_2: "609e51f7a601860015b41871",
  //       sessions: null,
  //       one: "",
  //       two: "",
  //       three: "",
  //       four: "",
  //       five: "",
  //       six: "",
  //       seven: "",
  //       eight: "",
  //       nine: "",
  //       ten: "",
  //     };
  //   },
  //   methods: {
  //     async getSessionsForIDs() {
  //       this.sessions = await getSessionsForIDs(this.UID_1, this.UID_2);
  //       this.one = this.sessions[99];
  //       this.two = this.sessions[199];
  //       this.three = this.sessions[299];
  //       this.four = this.sessions[399];
  //       this.five = this.sessions[499];
  //       this.six = this.sessions[599];
  //       this.seven = this.sessions[699];
  //       this.eight = this.sessions[799];
  //       this.nine = this.sessions[899];
  //       this.ten = this.sessions[999];
  //     },
  //   },
  //   computed: {
  //     firstSession() {
  //       let sessions = this.sessions;
  //       sessions = sessions.sort(function (a, b) {
  //         return new Date(a.dateTime) - new Date(b.dateTime);
  //       });
  //       return sessions[0];
  //     },
  //   },
};
</script>
<style scoped>
.story {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.block {
  width: 800px;
  margin: 10px auto;
  margin-bottom: 30px;
  height: 500px;
  /* border: 10px double black; */
  border-radius: 3px;
  background-color: white;
  font-family: "Nunito", sans-serif;
  font-weight: 600;
  font-size: 30px;
  line-height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px 60px;
  text-align: center;
}
.image {
  max-width: 800px;
  margin: 10px auto;
  margin-bottom: 30px;
  border-radius: 3px;
  object-fit: cover;
}
.datetime {
  background-color: #4b00ff;
  border-radius: 360px;
  padding: 3px 20px;
  color: white;
  font-size: 24px;
  font-weight: 700;
}
.video {
  margin: 10px auto;
  margin-bottom: 30px;
  border-radius: 3px;
}
.play {
  border-radius: 360px;
  background-color: #f70094;
  color: white;
  padding: 2px 20px;
  font-size: 26px;
  cursor: pointer;
}
.images {
  width: 800px;
  line-height: 0;
  -webkit-column-count: 2;
  -webkit-column-gap: 10px;
  -moz-column-count: 2;
  -moz-column-gap: 10px;
  column-count: 2;
  column-gap: 10px;
  box-sizing: border-box;
  margin: 0 auto;
}
</style>